import api from "@/api.js";

export default {
  state: {
    siteData: {},
    fullLoading: true,
    navigationDrawer: true,
    siteSettings: {}
  },
  mutations: {
    setFullLoader(state, loading) {
      setTimeout(() => {
        state.fullLoading = loading;
      }, 500);
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    }
  },
  actions: {
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },

    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },
    async syncToggl({ dispatch }) {
      await api.get("toggl/syncWithToggl");
      dispatch("loadProjects", []);
    }
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    }
  }
};
